import type { IconNode } from '../types';

/**
 * @name bangladeshi-taka
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiA1YTIgMiAwIDAgMSA0IDB2MTJhNCA0IDAgMCAwIDggMCAyIDIgMCAwIDAtNCAwIiAvPgogIDxwYXRoIGQ9Ik02IDloMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/bangladeshi-taka
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const BangladeshiTaka: IconNode = [
  ['path', { d: 'M6 5a2 2 0 0 1 4 0v12a4 4 0 0 0 8 0 2 2 0 0 0-4 0' }],
  ['path', { d: 'M6 9h12' }],
];

export default BangladeshiTaka;
